
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salon/[kickbackFeeCode]",
      function () {
        return require("private-next-pages/salon/[kickbackFeeCode].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/salon/[kickbackFeeCode]"])
      });
    }
  